import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "product-detail__shell" }
const _hoisted_2 = { class: "product-detail__crumb" }
const _hoisted_3 = { class: "product-detail__layout" }
const _hoisted_4 = { class: "product-detail__gallery-stage" }
const _hoisted_5 = {
  key: 0,
  class: "product-detail__thumbs",
  "aria-label": "상품 이미지 목록"
}
const _hoisted_6 = ["aria-label", "onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "product-detail__hero-badge"
}
const _hoisted_10 = { class: "product-detail__hero-unit" }
const _hoisted_11 = {
  key: 1,
  class: "product-detail__hero-soldout"
}
const _hoisted_12 = {
  key: 0,
  class: "product-detail__pager",
  "aria-label": "상품 이미지 넘기기"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "product-detail__pager-count" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "product-detail__body" }
const _hoisted_18 = ["aria-selected", "id", "aria-controls", "onClick"]
const _hoisted_19 = { class: "product-detail__info" }
const _hoisted_20 = {
  id: "panel-detail",
  class: "product-detail__section",
  role: "tabpanel",
  "aria-labelledby": "tab-detail"
}
const _hoisted_21 = { class: "product-detail__specs-head" }
const _hoisted_22 = ["aria-expanded"]
const _hoisted_23 = {
  key: 1,
  class: "product-detail__desc"
}
const _hoisted_24 = {
  key: 2,
  class: "product-detail__blocks"
}
const _hoisted_25 = {
  key: 0,
  class: "product-detail__block-heading"
}
const _hoisted_26 = {
  key: 1,
  class: "product-detail__block-text"
}
const _hoisted_27 = {
  key: 2,
  class: "product-detail__block-notice"
}
const _hoisted_28 = {
  key: 3,
  class: "product-detail__block-image"
}
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "product-detail__notice" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  id: "panel-review",
  class: "product-detail__section",
  role: "tabpanel",
  "aria-labelledby": "tab-review"
}
const _hoisted_34 = {
  key: 0,
  class: "product-detail__write"
}
const _hoisted_35 = {
  key: 0,
  class: "product-detail__order-pick"
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  class: "product-detail__stars-pick",
  role: "group",
  "aria-label": "별점"
}
const _hoisted_39 = ["aria-label", "onClick"]
const _hoisted_40 = { class: "product-detail__photo-pick" }
const _hoisted_41 = { class: "product-detail__photo-btn" }
const _hoisted_42 = ["src"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "product-detail__write-note"
}
const _hoisted_45 = {
  key: 2,
  class: "product-detail__write-note"
}
const _hoisted_46 = {
  key: 3,
  class: "product-detail__review-tools"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 4,
  class: "product-detail__reviews"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "product-detail__reply"
}
const _hoisted_52 = {
  key: 5,
  class: "product-detail__empty-review"
}
const _hoisted_53 = {
  id: "panel-qna",
  class: "product-detail__section",
  role: "tabpanel",
  "aria-labelledby": "tab-qna"
}
const _hoisted_54 = {
  key: 0,
  class: "product-detail__write"
}
const _hoisted_55 = { class: "product-detail__write-note" }
const _hoisted_56 = { class: "product-detail__order-pick" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "product-detail__secret" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 1,
  class: "product-detail__write-note"
}
const _hoisted_64 = {
  key: 2,
  class: "product-detail__reviews"
}
const _hoisted_65 = {
  key: 0,
  class: "product-detail__secret-tag"
}
const _hoisted_66 = {
  key: 0,
  class: "product-detail__reply"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 1,
  class: "product-detail__wait"
}
const _hoisted_69 = {
  key: 3,
  class: "product-detail__empty-review"
}
const _hoisted_70 = {
  id: "panel-shipping",
  class: "product-detail__section",
  role: "tabpanel",
  "aria-labelledby": "tab-shipping"
}
const _hoisted_71 = { class: "product-detail__ship-policy" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { key: 3 }
const _hoisted_76 = {
  key: 0,
  class: "product-detail__policy-list"
}
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = {
  key: 0,
  class: "product-detail__related"
}
const _hoisted_79 = { class: "product-detail__related-grid" }
const _hoisted_80 = {
  key: 1,
  class: "product-detail__related"
}
const _hoisted_81 = { class: "product-detail__related-grid" }
const _hoisted_82 = {
  key: 2,
  class: "product-detail__related"
}
const _hoisted_83 = { class: "product-detail__related-grid" }
const _hoisted_84 = {
  key: 3,
  class: "product-detail__related"
}
const _hoisted_85 = { class: "product-detail__related-grid" }
const _hoisted_86 = { class: "product-detail__buy-card" }
const _hoisted_87 = { class: "product-detail__buy-scroll" }
const _hoisted_88 = { class: "product-detail__buy-block" }
const _hoisted_89 = { class: "product-detail__store-row" }
const _hoisted_90 = {
  key: 1,
  class: "product-detail__store"
}
const _hoisted_91 = { class: "product-detail__tools" }
const _hoisted_92 = { class: "product-detail__title" }
const _hoisted_93 = {
  class: "product-detail__stars",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "product-detail__buy-block" }
const _hoisted_95 = { class: "product-detail__price-row" }
const _hoisted_96 = {
  key: 0,
  class: "product-detail__amount"
}
const _hoisted_97 = {
  key: 1,
  class: "product-detail__amount"
}
const _hoisted_98 = {
  key: 0,
  class: "product-detail__unit"
}
const _hoisted_99 = {
  key: 1,
  class: "product-detail__unit"
}
const _hoisted_100 = { class: "product-detail__buy-block" }
const _hoisted_101 = { class: "product-detail__buy-facts" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 2 }
const _hoisted_105 = { class: "product-detail__buy-block" }
const _hoisted_106 = { class: "product-detail__options" }
const _hoisted_107 = {
  key: 0,
  class: "product-detail__option-label",
  for: "pdp-option-pick"
}
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 0,
  value: ""
}
const _hoisted_110 = ["value", "disabled"]
const _hoisted_111 = {
  key: 3,
  class: "product-detail__picks"
}
const _hoisted_112 = { class: "product-detail__pick-meta" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { class: "product-detail__pick-ops" }
const _hoisted_116 = {
  key: 5,
  class: "product-detail__qty-hint"
}
const _hoisted_117 = { class: "product-detail__buy-block product-detail__buy-block--foot" }
const _hoisted_118 = { class: "product-detail__total" }
const _hoisted_119 = { class: "product-detail__total-copy" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { key: 1 }
const _hoisted_122 = { class: "product-detail__actions" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { class: "product-detail__action-row" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = {
  key: 0,
  class: "product-detail__login-note"
}
const _hoisted_127 = {
  key: 0,
  class: "product-detail__toast"
}
const _hoisted_128 = {
  class: "product-detail__sticky",
  "aria-label": "구매 바로가기"
}
const _hoisted_129 = ["disabled"]
const _hoisted_130 = ["disabled"]
const _hoisted_131 = {
  key: 1,
  class: "product-detail__missing"
}
const _hoisted_132 = {
  key: 2,
  class: "product-detail__missing"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ProductCard from '@/components/mall/ProductCard.vue'
import QtyStepper from '@/components/mall/QtyStepper.vue'
import MallOrderPackMark from '@/components/mall/MallOrderPackMark.vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { setBuyNowKeys } from '@/composables/useBuyNowCheckout'
import { cartKey, useCart } from '@/composables/useCart'
import { useCartSelection } from '@/composables/useCartSelection'
import { useMallAuth } from '@/composables/useMallAuth'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { useRecentlyViewed } from '@/composables/useRecentlyViewed'
import { useWishlist } from '@/composables/useWishlist'
import { fetchMallProduct } from '@/api/mall'
import { fetchLastPurchaseQty, MALL_ORDER_STATUS_LABEL } from '@/api/mallOrder'
import {
  fetchRestockNotifyStatus,
  subscribeRestockNotify,
  unsubscribeRestockNotify,
} from '@/api/mallProduct'
import {
  createProductQna,
  createProductReview,
  fetchMyReviewStatus,
  fetchQnaOrders,
  uploadMemberImages,
  type MallQnaOrderOption,
} from '@/api/mallReview'
import { MALL_FULFILLMENT_LIMIT, mallStorePath } from '@/constants/mall'
import { memberLoginTo } from '@/utils/authRedirect'
import { getAllProducts, formatPrice, type MallProduct, type MallProductOption } from '@/constants/mallProducts'
import { useContentSnippets, useSameDayCutoffText, SNIPPET_FALLBACKS } from '@/composables/useContentSnippets'
import { calcMallUnitPrice } from '@/utils/mallPricing'
import { formatShippingFeeAmount, toShippingLine } from '@/utils/mallShipping'
import {
  calcOrderShippingFromLines,
  formatMinOrderLabel,
  formatShippingChargeLabel,
  formatStockCount,
  imageShowsCaption,
  isOrderPack,
  optionPieceCount,
  sellUnitNoun,
  sellUnitSummary,
  snapOrderQty,
} from '@/utils/mallSell'

type TabId = (typeof tabs)[number]['id']

type SelectedLine = {
  key: string
  optionName: string
  optionExtra: number
  qty: number
}

/* 옵션은 하나만 고른다. 수량은 그 옵션만 올리고, 옵션을 바꾸면 1부터 다시 센다. */

export default /*@__PURE__*/_defineComponent({
  __name: 'MallProductPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loginTo = computed(() => memberLoginTo(route.fullPath))
const { addItem } = useCart()
const { selectOnly } = useCartSelection()
const { isWished, toggleWish } = useWishlist()
const { ensureLoggedIn } = useMallAuth()
const { isLoggedIn } = useMemberAuth()
const { recentIds, pushRecent } = useRecentlyViewed()
const { loadSnippets, snippet } = useContentSnippets()

const trustBadge = computed(() => snippet('mall.product.trust_badge') || SNIPPET_FALLBACKS['mall.product.trust_badge'])
const shippingNotesHtml = computed(
  () => snippet('mall.product.shipping_notes') || SNIPPET_FALLBACKS['mall.product.shipping_notes'],
)
const returnPolicyHtml = computed(
  () => snippet('mall.product.return_policy') || SNIPPET_FALLBACKS['mall.product.return_policy'],
)
const storeReturnPolicyLines = computed(() =>
  String(product.value?.storeReturnPolicy || '')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean),
)

const tabs = [
  { id: 'detail', label: '상세정보' },
  { id: 'review', label: '구매후기' },
  { id: 'qna', label: '상품문의' },
  { id: 'shipping', label: '배송/교환' },
] as const

const activeTab = ref<TabId>('detail')
const tabsEl = ref<HTMLElement | null>(null)
const galleryEl = ref<HTMLElement | null>(null)
const buyEl = ref<HTMLElement | null>(null)
/** 탭 높이만 페이지에서 잡고, 헤더 offset 은 MallHeader 가 전역으로 공개한다. */
const stickyCssVars = computed(() => ({
  '--mall-tab-offset': `${tabsEl.value?.offsetHeight ?? 52}px`,
}))
/** 탭 클릭으로 스크롤 중일 때는 spy가 탭을 되돌려 놓지 않게 한다 */
let scrollingByClick = false
let scrollUnlockTimer: ReturnType<typeof setTimeout> | undefined
let scrollSpyRaf = 0
let buyResizeObserver: ResizeObserver | null = null

function headerOffsetPx() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--mall-header-offset').trim()
  const n = Number.parseFloat(raw)
  return Number.isFinite(n) ? n : 0
}

function mallCssZoom(): number {
  const app = document.querySelector('.site-app--mall')
  const raw = getComputedStyle(app || document.documentElement).getPropertyValue('--mall-ui-zoom').trim()
  const n = Number.parseFloat(raw)
  return Number.isFinite(n) && n > 0 ? n : 1
}

/** 큰 모니터 CSS zoom · 브라우저 배율 · 빵부스러기까지 반영해 구매 카드를 화면 안에 가둔다 */
function fitBuyPanelToViewport() {
  const card = buyEl.value?.querySelector('.product-detail__buy-card') as HTMLElement | null
  if (!card) return
  if (window.innerWidth <= 960) {
    card.style.removeProperty('--buy-max-h')
    return
  }

  const visualTop = card.getBoundingClientRect().top
  const visualView = window.visualViewport?.height ?? window.innerHeight
  const visualRemain = visualView - visualTop - 12
  const visualH = card.getBoundingClientRect().height
  const layoutH = card.offsetHeight
  const zoom = visualH > 1 && layoutH > 1 ? visualH / layoutH : mallCssZoom()
  const layoutMax = Math.max(280, Math.floor(visualRemain / zoom))
  card.style.setProperty('--buy-max-h', `${layoutMax}px`)
}

/** 대표 사진 세로를 오른쪽 구매 카드에 맞춘 정사각으로 둔다 */
function syncGalleryHeight() {
  const gallery = galleryEl.value
  const buyCard = buyEl.value?.querySelector('.product-detail__buy-card') as HTMLElement | null
  if (!gallery) return

  if (!buyCard || window.innerWidth <= 960) {
    gallery.style.removeProperty('--gallery-hero-height')
    return
  }

  const thumbs = gallery.querySelector('.product-detail__thumbs') as HTMLElement | null
  const thumbsW = thumbs ? Math.ceil(thumbs.getBoundingClientRect().width) + 12 : 0
  const buyH = Math.round(buyCard.getBoundingClientRect().height)
  const colW = gallery.parentElement?.clientWidth || buyH
  const size = Math.max(280, Math.min(buyH, colW - thumbsW))
  gallery.style.setProperty('--gallery-hero-height', `${size}px`)
}

function bindGalleryHeightSync() {
  buyResizeObserver?.disconnect()
  buyResizeObserver = null
  const buyCard = buyEl.value?.querySelector('.product-detail__buy-card')
  if (!buyCard || typeof ResizeObserver === 'undefined') {
    fitBuyPanelToViewport()
    syncGalleryHeight()
    return
  }
  buyResizeObserver = new ResizeObserver(() => {
    syncGalleryHeight()
  })
  buyResizeObserver.observe(buyCard)
  fitBuyPanelToViewport()
  syncGalleryHeight()
}

const qty = ref(1)
const lastPurchaseQty = ref<number | null>(null)
const specsOpen = ref(false)
const toast = ref('')
let toastTimer: ReturnType<typeof setTimeout> | undefined

/* 판매업체가 올린 상품은 서버에서 받아야 상세 블록·후기까지 나온다. */
const product = ref<MallProduct | null>(null)
const { sameDayCutoffText } = useSameDayCutoffText(() => product.value?.storeCutoff)
const hasStoreReturnFee = computed(
  () => Boolean(product.value?.sellerCode),
)
const sellNoun = computed(() => sellUnitNoun(product.value?.sellUnit))
const imageCaption = computed(() =>
  product.value ? imageShowsCaption(product.value) : '사진은 상품 1개입니다',
)
const sellSummary = computed(() => (product.value ? sellUnitSummary(product.value) : '1개'))
const productShippingLabel = computed(() => {
  const label = product.value ? formatShippingChargeLabel(product.value) : formatShippingFeeAmount(0)
  return label === '무료' ? '무료배송' : label
})
const returnShippingLabel = computed(() => {
  const every = Math.max(1, Number(product.value?.returnEvery) || 10)
  const fee = Math.max(0, Number(product.value?.returnFee) || 0)
  if (!fee) return '없음'
  const noun = sellNoun.value
  const money = fee.toLocaleString('ko-KR')
  return `${every}${noun}당 ${money}원 · ${every}${noun} 이하는 ${money}원`
})

const minQty = computed(() => Math.max(1, product.value?.minOrder || 1))
const orderStep = computed(() => Math.max(1, product.value?.orderStep || 1))
const isPack = computed(() => isOrderPack(orderStep.value))
const isGroupBuy = computed(() => product.value?.mallKind === 'SALE')
const cartonPieces = computed(() => Math.max(1, product.value?.packQty || orderStep.value || 1))
const cartonPrice = computed(() => priced.value.unitPrice * cartonPieces.value)
function cartonCount(qty: number) {
  return Math.max(1, Math.round((Number(qty) || cartonPieces.value) / cartonPieces.value))
}
const stockQty = computed(() => Math.max(0, Number(product.value?.stock) || 0))
const maxQty = computed(() => {
  const stock = stockQty.value
  /* 주문 상한은 재고만. */
  return Math.max(minQty.value, stock > 0 ? stock : minQty.value)
})

const qtyHint = computed(() => {
  if (product.value?.soldOut || stockQty.value <= 0) return '품절'
  if (isPack.value) return ''
  if (minQty.value > 1) return formatMinOrderLabel(minQty.value, product.value?.sellUnit)
  return ''
})

function clampQty(value: number) {
  return snapOrderQty(value, minQty.value, orderStep.value, maxQty.value)
}

async function loadLastPurchase(productId: string) {
  lastPurchaseQty.value = null
  if (!isLoggedIn.value || !productId) return
  try {
    const qtyValue = await fetchLastPurchaseQty(productId)
    lastPurchaseQty.value = qtyValue && qtyValue > 0 ? qtyValue : null
  } catch {
    lastPurchaseQty.value = null
  }
}

function applyLastPurchase() {
  if (!lastPurchaseQty.value) return
  const next = clampQty(lastPurchaseQty.value)
  qty.value = next
  if (selectedLines.value.length) {
    selectedLines.value = selectedLines.value.map((line) => ({ ...line, qty: next }))
  }
}

const visibleHighlights = computed(() => {
  const list = product.value?.highlights || []
  if (specsOpen.value || list.length <= 4) return list
  return list.slice(0, 4)
})
const loading = ref(true)
const activeImageIndex = ref(0)
const zoomOpen = ref(false)
const zoomScale = ref(1)
let touchStartX = 0
let swipeMoved = false
let pinchStartDist = 0
let pinchStartScale = 1

function openZoom() {
  if (swipeMoved) {
    swipeMoved = false
    return
  }
  zoomOpen.value = true
  zoomScale.value = 1
}

function closeZoom() {
  zoomOpen.value = false
  zoomScale.value = 1
}

const canGoPrev = computed(() => gallery.value.length > 1 && activeImageIndex.value > 0)
const canGoNext = computed(
  () => gallery.value.length > 1 && activeImageIndex.value < gallery.value.length - 1,
)

function prevImage() {
  if (!canGoPrev.value) return
  activeImageIndex.value -= 1
}

function nextImage() {
  if (!canGoNext.value) return
  activeImageIndex.value += 1
}

function onHeroTouchStart(event: TouchEvent) {
  swipeMoved = false
  touchStartX = event.changedTouches[0]?.clientX ?? 0
}

function onHeroTouchEnd(event: TouchEvent) {
  if (gallery.value.length < 2) return
  const endX = event.changedTouches[0]?.clientX ?? touchStartX
  const delta = endX - touchStartX
  if (Math.abs(delta) < 40) return
  swipeMoved = true
  if (delta < 0) nextImage()
  else prevImage()
}

function onZoomWheel(event: WheelEvent) {
  const next = zoomScale.value + (event.deltaY < 0 ? 0.12 : -0.12)
  zoomScale.value = Math.min(3, Math.max(1, next))
}

function pinchDistance(event: TouchEvent) {
  if (event.touches.length < 2) return 0
  const a = event.touches[0]
  const b = event.touches[1]
  return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY)
}

function onPinchStart(event: TouchEvent) {
  if (event.touches.length < 2) return
  pinchStartDist = pinchDistance(event)
  pinchStartScale = zoomScale.value
}

function onPinchMove(event: TouchEvent) {
  if (event.touches.length < 2 || !pinchStartDist) return
  const ratio = pinchDistance(event) / pinchStartDist
  zoomScale.value = Math.min(3, Math.max(1, pinchStartScale * ratio))
}

function onPinchEnd() {
  pinchStartDist = 0
}

const canReview = ref(false)
const myReview = ref(false)
const reviewBusy = ref(false)
const qnaBusy = ref(false)
const reviewForm = reactive({ rating: 5, content: '', orderCode: '' })
const reviewImageFile = ref<File | null>(null)
const reviewImagePreview = ref('')
const photoReviewsOnly = ref(false)
const qnaForm = reactive({ kind: '' as '' | 'order' | 'general', question: '', secret: false, orderCode: '' })
const qnaOrders = ref<MallQnaOrderOption[]>([])
const qnaOrdersLoading = ref(false)
const restockSubscribed = ref(false)
const restockBusy = ref(false)

function formatQnaOrderOption(order: MallQnaOrderOption) {
  const when = String(order.orderedAt || '').slice(0, 10)
  const status =
    MALL_ORDER_STATUS_LABEL[order.status as keyof typeof MALL_ORDER_STATUS_LABEL] || order.status
  const summary = order.itemSummary || '주문 상품'
  return `${when} · ${order.code} · ${status} · ${summary}`
}

async function loadQnaOrders() {
  if (!isLoggedIn.value || !product.value?.id?.startsWith('MP')) {
    qnaOrders.value = []
    qnaForm.orderCode = ''
    return
  }
  qnaOrdersLoading.value = true
  try {
    qnaOrders.value = await fetchQnaOrders(product.value.id)
    const fromQuery = String(route.query.order || '').trim()
    if (fromQuery && qnaOrders.value.some((row) => row.code === fromQuery)) {
      qnaForm.orderCode = fromQuery
    } else if (qnaForm.orderCode && !qnaOrders.value.some((row) => row.code === qnaForm.orderCode)) {
      qnaForm.orderCode = ''
    }
    pickDefaultQnaOrder()
    if (!reviewForm.orderCode || !qnaOrders.value.some((row) => row.code === reviewForm.orderCode)) {
      reviewForm.orderCode = qnaOrders.value[0]?.code || ''
    }
  } catch {
    qnaOrders.value = []
  } finally {
    qnaOrdersLoading.value = false
  }
}

function pickDefaultQnaOrder() {
  if (qnaForm.orderCode && qnaOrders.value.some((row) => row.code === qnaForm.orderCode)) return
  qnaForm.orderCode = qnaOrders.value[0]?.code || ''
}

const isLive = computed(() => Boolean(product.value?.storeName || product.value?.id?.startsWith('MP')))
const canWriteReview = computed(() => isLive.value && isLoggedIn.value && canReview.value && !myReview.value)
const photoReviewCount = computed(
  () => product.value?.reviews.filter((review) => Boolean(review.image)).length || 0,
)
const visibleReviews = computed(() => {
  const list = product.value?.reviews || []
  return photoReviewsOnly.value ? list.filter((review) => Boolean(review.image)) : list
})

function canSeeQna(item: { secret?: boolean; question: string }) {
  return !item.secret || item.question !== '비밀 문의입니다.'
}

function qnaVisibleText(item: { question: string }) {
  return item.question
}

function onReviewImagePick(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  input.value = ''
  if (!file) return
  if (file.size > 5 * 1024 * 1024) {
    showToast('사진은 5MB 이하만 첨부할 수 있습니다.')
    return
  }
  if (reviewImagePreview.value) URL.revokeObjectURL(reviewImagePreview.value)
  reviewImageFile.value = file
  reviewImagePreview.value = URL.createObjectURL(file)
}

function clearReviewImage() {
  if (reviewImagePreview.value) URL.revokeObjectURL(reviewImagePreview.value)
  reviewImageFile.value = null
  reviewImagePreview.value = ''
}

async function loadRestockStatus(productId: string, soldOut: boolean) {
  restockSubscribed.value = false
  if (!soldOut || !isLoggedIn.value || !productId.startsWith('MP')) return
  try {
    restockSubscribed.value = await fetchRestockNotifyStatus(productId)
  } catch {
    restockSubscribed.value = false
  }
}

async function toggleRestock() {
  if (!product.value || !ensureLoggedIn() || restockBusy.value) return
  restockBusy.value = true
  try {
    if (restockSubscribed.value) {
      await unsubscribeRestockNotify(product.value.id)
      restockSubscribed.value = false
      showToast('재입고 알림 신청을 취소했습니다.')
    } else {
      await subscribeRestockNotify(product.value.id)
      restockSubscribed.value = true
      showToast('재입고되면 알려 드리겠습니다.')
    }
  } catch (error) {
    showToast(error instanceof Error ? error.message : '재입고 알림 처리에 실패했습니다.')
  } finally {
    restockBusy.value = false
  }
}

async function loadReviewStatus(productId: string) {
  canReview.value = false
  myReview.value = false
  if (!isLoggedIn.value || !productId.startsWith('MP')) {
    return
  }

  try {
    const status = await fetchMyReviewStatus(productId)
    canReview.value = status.canReview && !status.myReview
    myReview.value = Boolean(status.myReview)
  } catch {
    canReview.value = false
  }
}

async function loadProduct() {
  loading.value = true
  activeImageIndex.value = 0
  specsOpen.value = false
  lastPurchaseQty.value = null
  product.value = await fetchMallProduct(route.params.id as string)
  loading.value = false
  if (product.value) {
    qty.value = clampQty(minQty.value)
    pushRecent(product.value.id)
    await Promise.all([
      loadReviewStatus(product.value.id),
      loadRestockStatus(product.value.id, Boolean(product.value.soldOut)),
      loadLastPurchase(product.value.id),
      loadQnaOrders(),
    ])
  }
}

void loadProduct().then(() => {
  void nextTick(() => {
    bindGalleryHeightSync()
    if (route.query.tab) applyTabQuery(true)
    else syncActiveTabByScroll()
  })
})

async function submitReview() {
  if (!product.value || !ensureLoggedIn() || reviewBusy.value) return
  reviewBusy.value = true
  try {
    let image = ''
    if (reviewImageFile.value) {
      const uploaded = await uploadMemberImages([reviewImageFile.value])
      image = uploaded[0]?.url || ''
    }
    const review = await createProductReview(product.value.id, {
      rating: reviewForm.rating,
      content: reviewForm.content,
      image: image || undefined,
      orderCode: reviewForm.orderCode || undefined,
    })
    const prevCount = product.value.reviewCount
    const nextCount = prevCount + 1
    const nextRating =
      Math.round(((product.value.rating * prevCount + review.rating) / nextCount) * 10) / 10
    product.value = {
      ...product.value,
      reviews: [review, ...product.value.reviews],
      reviewCount: nextCount,
      rating: nextRating,
    }
    reviewForm.content = ''
    reviewForm.orderCode = ''
    clearReviewImage()
    canReview.value = false
    myReview.value = true
    showToast('구매후기를 등록했습니다.')
  } catch (error) {
    showToast(error instanceof Error ? error.message : '구매후기 등록에 실패했습니다.')
  } finally {
    reviewBusy.value = false
  }
}

async function submitQna() {
  if (!product.value || !ensureLoggedIn() || qnaBusy.value) return
  if (!product.value.id.startsWith('MP')) {
    showToast('이 상품에는 문의를 남길 수 없습니다.')
    return
  }
  if (!qnaForm.orderCode) {
    showToast('주문내역에서 해당 주문을 골라 주세요.')
    return
  }

  qnaBusy.value = true
  try {
    const qna = await createProductQna(product.value.id, {
      question: qnaForm.question,
      secret: qnaForm.secret,
      orderCode: qnaForm.orderCode,
    })
    product.value = {
      ...product.value,
      qnas: [qna, ...(product.value.qnas || [])],
    }
    qnaForm.question = ''
    qnaForm.secret = false
    showToast('문의를 등록했습니다.')
  } catch (error) {
    showToast(error instanceof Error ? error.message : '문의 등록에 실패했습니다.')
  } finally {
    qnaBusy.value = false
  }
}

const gallery = computed(() => {
  if (!product.value) return []
  const list = product.value.images?.length ? product.value.images : [product.value.image]
  return list.filter(Boolean)
})

const activeImage = computed(() => gallery.value[activeImageIndex.value] ?? product.value?.image ?? '')

const detailBlocks = computed(() => product.value?.blocks ?? [])

const optionPick = ref('')
const selectedLines = ref<SelectedLine[]>([])

/* 상품은 항상 옵션을 가진다. 한 개면 옵션 1개 상품이다. */
const productOptions = computed(() =>
  (product.value?.options ?? []).filter((option) => option.use !== false && option.name.trim()),
)

const optionGroups = computed(() => {
  const groups = new Map<string, MallProductOption[]>()

  productOptions.value.forEach((option) => {
    const groupName = option.group?.trim() || '구성'
    const list = groups.get(groupName) ?? []
    list.push(option)
    groups.set(groupName, list)
  })

  return [...groups.entries()].map(([name, items]) => ({ name, items }))
})

function choiceMoneyLabel(name: string, extra: number) {
  const total = Math.max(0, (Number(product.value?.price) || 0) + (Number(extra) || 0))
  const qty = optionPieceCount(name)
  const totalText = `${formatPrice(total)}원`
  if (qty === 1) return `${name} ${totalText}`
  if (qty && qty > 1) return `${name} ${totalText} · 개당 ${formatPrice(Math.round(total / qty))}원`
  if (extra) return `${name} (${extra > 0 ? '+' : ''}${formatPrice(extra)}원)`
  return name
}

const flatOptionChoices = computed(() => {
  const groups = optionGroups.value
  if (!groups.length) return [] as Array<{ name: string; label: string; extra: number; stock: number }>

  const flatItems = groups.flatMap((group) => group.items)
  const quantityList =
    flatItems.length > 0 && flatItems.every((option) => optionPieceCount(option.name) != null)
  if (groups.length === 1 || quantityList) {
    return (quantityList ? flatItems : groups[0].items)
      .map((option) => ({
        name: option.name,
        label: choiceMoneyLabel(option.name, option.extra),
        extra: option.extra,
        stock: option.stock,
      }))
      .sort((a, b) => (optionPieceCount(a.name) ?? 9999) - (optionPieceCount(b.name) ?? 9999))
  }

  /* 그룹이 여러 개면 "구성 / 사이즈"처럼 조합 라벨로 펼친다 */
  const [first, ...rest] = groups
  let combos = first.items.map((option) => ({
    parts: [option.name],
    extra: option.extra,
    stock: option.stock,
  }))
  rest.forEach((group) => {
    const next: typeof combos = []
    combos.forEach((combo) => {
      group.items.forEach((option) => {
        next.push({
          parts: [...combo.parts, option.name],
          extra: combo.extra + option.extra,
          stock: Math.min(combo.stock, option.stock),
        })
      })
    })
    combos = next
  })

  return combos.map((combo) => {
    const name = combo.parts.join(' / ')
    return {
      name,
      label: choiceMoneyLabel(name, combo.extra),
      extra: combo.extra,
      stock: combo.stock,
    }
  })
})

/* 주문·재고는 상품(mp_stock) 기준. 옵션 재고가 전부 0인 옛 데이터는 상품 판매중이면 선택 가능으로 본다. */
const hasBasePriceChoice = computed(() =>
  flatOptionChoices.value.some((item) => optionPieceCount(item.name) === 1 || item.extra === 0),
)

const tracksOptionStock = computed(() => {
  const choices = flatOptionChoices.value
  if (choices.length && choices.every((item) => optionPieceCount(item.name) != null)) return false
  return choices.some((item) => item.stock > 0)
})

function isChoiceAvailable(choice: { stock: number }) {
  if (!product.value || product.value.soldOut) return false
  if (!tracksOptionStock.value) return true
  return choice.stock > 0
}

function choiceLabel(choice: { name: string; label: string; stock: number }) {
  return isChoiceAvailable(choice) ? choice.label : `${choice.label} · 품절`
}

function seedDefaultLine() {
  selectedLines.value = []
  optionPick.value = ''
  if (!product.value) return

  /* 기본 선택은 1개. 1개가 없으면 판매가와 같은 옵션만 고른다. */
  const choices = flatOptionChoices.value
  const choice =
    choices.find((item) => optionPieceCount(item.name) === 1 && isChoiceAvailable(item)) ??
    choices.find((item) => optionPieceCount(item.name) === 1) ??
    choices.find((item) => item.extra === 0 && isChoiceAvailable(item)) ??
    choices.find((item) => item.extra === 0)
  if (!choice) return

  optionPick.value = choice.name
  if (!isChoiceAvailable(choice)) return

  selectedLines.value = [
    {
      key: `${product.value.id}::${choice.name}`,
      optionName: choice.name,
      optionExtra: choice.extra,
      qty: clampQty(minQty.value),
    },
  ]
}

watch(
  () => {
    if (!product.value) return ''
    const opts = productOptions.value
      .map((option) => `${option.group}:${option.name}:${option.extra}:${option.stock}`)
      .join('|')
    return `${product.value.id}::${opts}`
  },
  () => {
    seedDefaultLine()
  },
)

function onOptionPick() {
  const name = optionPick.value
  if (!name || !product.value) return
  const choice = flatOptionChoices.value.find((item) => item.name === name)
  if (!choice || !isChoiceAvailable(choice)) {
    /* 품절이면 이전 선택(기본값)으로 되돌린다 */
    const fallback =
      selectedLines.value[0]?.optionName ||
      flatOptionChoices.value.find((item) => isChoiceAvailable(item))?.name ||
      ''
    optionPick.value = fallback
    return
  }

  if (selectedLines.value[0]?.optionName === name) return

  selectedLines.value = [
    {
      key: `${product.value.id}::${name}`,
      optionName: name,
      optionExtra: choice.extra,
      qty: clampQty(1),
    },
  ]
}

function setLineQty(key: string, raw: string | number) {
  const line = selectedLines.value.find((item) => item.key === key)
  if (!line) return
  const parsed = typeof raw === 'number' ? raw : Number(String(raw).trim())
  if (!Number.isFinite(parsed)) {
    line.qty = clampQty(minQty.value)
    return
  }
  line.qty = clampQty(Math.trunc(parsed))
}

const goodsAmount = computed(() => {
  if (!product.value) return 0
  if (selectedLines.value.length) {
    return selectedLines.value.reduce(
      (sum, line) => sum + lineUnitPrice(line.optionExtra) * line.qty,
      0,
    )
  }
  return priced.value.unitPrice * qty.value
})

const pickQty = computed(() => {
  if (selectedLines.value.length) {
    return selectedLines.value.reduce((sum, line) => sum + line.qty, 0)
  }
  return qty.value
})

const orderShippingFee = computed(() => {
  if (!product.value) return 0
  return calcOrderShippingFromLines([toShippingLine(product.value, pickQty.value)])
})

/** 바로구매·장바구니와 같은 최종 결제 예정액(상품가 + 배송비) */
const totalAmount = computed(() => goodsAmount.value + orderShippingFee.value)

const priced = computed(() =>
  calcMallUnitPrice({
    listPrice: product.value?.listPrice,
    salePrice: product.value?.price ?? 0,
  }),
)

function lineUnitPrice(optionExtra = 0): number {
  if (!product.value) return 0
  return calcMallUnitPrice({
    listPrice: product.value.listPrice,
    salePrice: product.value.price,
    optionExtra,
  }).unitPrice
}

const wished = computed(() => (product.value ? isWished(product.value.id) : false))

function pickByCodes(codes: string[] | undefined, limit: number) {
  if (!codes?.length) return []
  const selfId = product.value?.id
  const catalog = new Map(getAllProducts().map((item) => [item.id, item]))
  return codes
    .map((id) => catalog.get(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item) && item!.id !== selfId)
    .slice(0, limit)
}

const related = computed(() => {
  if (!product.value) return []
  const pinned = pickByCodes(product.value.relatedCodes, 8)
  if (pinned.length) return pinned
  return getAllProducts()
    .filter((item) => item.category === product.value!.category && item.id !== product.value!.id)
    .sort((a, b) => b.soldCount - a.soldCount)
    .slice(0, 8)
})

const alsoRecommend = computed(() => {
  if (!product.value) return []
  const skip = new Set([product.value.id, ...related.value.map((item) => item.id)])
  return getAllProducts()
    .filter((item) => !skip.has(item.id) && !item.soldOut)
    .sort((a, b) => b.soldCount - a.soldCount)
    .slice(0, 4)
})

const recentOthers = computed(() => {
  if (!product.value) return []
  const catalog = new Map(getAllProducts().map((item) => [item.id, item]))
  return recentIds.value
    .filter((id) => id !== product.value!.id)
    .map((id) => catalog.get(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item))
    .slice(0, 4)
})

/* 품절 시 관리자 지정 대체품 → 없으면 같은 분류 재고 있는 상품 */
const substitutes = computed(() => {
  if (!product.value?.soldOut) return []
  const pinned = pickByCodes(product.value.substituteCodes, 4).filter((item) => !item.soldOut)
  if (pinned.length) return pinned
  return getAllProducts()
    .filter(
      (item) =>
        !item.soldOut &&
        item.category === product.value!.category &&
        item.id !== product.value!.id,
    )
    .sort((a, b) => b.soldCount - a.soldCount)
    .slice(0, 4)
})

const showToast = (message: string) => {
  toast.value = message
  window.clearTimeout(toastTimer)
  toastTimer = setTimeout(() => {
    toast.value = ''
  }, 2800)
}

const onWish = () => {
  if (!product.value || !ensureLoggedIn()) return
  const next = !isWished(product.value.id)
  toggleWish(product.value.id)
  showToast(next ? '찜했습니다.' : '찜을 해제했습니다.')
}

async function onShare() {
  if (!product.value) return
  const { shareMallProduct } = await import('@/utils/mallShare')
  const result = await shareMallProduct({
    title: product.value.name,
    text: `${product.value.name} — 함우리몰`,
    url: `${window.location.origin}/mall/${product.value.id}`,
  })
  if (result === 'copied') showToast('상품 주소를 복사했습니다.')
  else if (result === 'shared') showToast('공유했습니다.')
}

function ensurePurchaseReady(): boolean {
  if (!product.value) return false
  /* 셀렉트에 값이 있는데 줄이 비었으면(기본 시드 누락) 한 번 더 맞춘다 */
  if (!selectedLines.value.length && optionPick.value) {
    onOptionPick()
  }
  if (!selectedLines.value.length) {
    showToast('옵션을 선택해 주세요.')
    return false
  }
  return true
}

async function pushSelectedLines(mode: 'add' | 'set' = 'add') {
  if (!product.value) return [] as string[]
  const keys: string[] = []
  for (const line of selectedLines.value) {
    await addItem(
      product.value.id,
      line.qty,
      {
        name: line.optionName,
        extra: line.optionExtra,
      },
      mode,
    )
    keys.push(cartKey(product.value.id, line.optionName))
  }
  return keys
}

const addToCart = async () => {
  if (!product.value || !ensureLoggedIn() || !ensurePurchaseReady()) return
  try {
    await pushSelectedLines('add')
    showToast('장바구니에 담았습니다.')
  } catch (error) {
    showToast(error instanceof Error ? error.message : '장바구니에 담지 못했습니다.')
  }
}

const buyNow = async () => {
  if (!product.value || !ensureLoggedIn() || !ensurePurchaseReady()) return
  try {
    /* 지금 보는 상품·옵션만 결제. 장바구니 다른 상품은 주문에 넣지 않는다. */
    const keys = await pushSelectedLines('set')
    if (!keys.length) {
      showToast('옵션을 선택해 주세요.')
      return
    }
    setBuyNowKeys(keys)
    selectOnly(keys)
    router.push({ path: '/mall/checkout', query: { mode: 'buynow' } })
  } catch (error) {
    showToast(error instanceof Error ? error.message : '장바구니에 담지 못했습니다.')
  }
}

function panelId(id: TabId) {
  return `panel-${id}`
}

function stickyOffset() {
  const tabBar = tabsEl.value?.offsetHeight ?? 52
  return headerOffsetPx() + tabBar
}

function scrollToTab(id: TabId) {
  const el = document.getElementById(panelId(id))
  if (!el) return

  activeTab.value = id
  scrollingByClick = true
  window.clearTimeout(scrollUnlockTimer)

  const top = el.getBoundingClientRect().top + window.scrollY - stickyOffset()
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })

  scrollUnlockTimer = setTimeout(() => {
    scrollingByClick = false
    syncActiveTabByScroll()
  }, 700)
}

function syncActiveTabByScroll() {
  if (scrollingByClick || !product.value) return

  const offset = stickyOffset()
  let current: TabId = tabs[0].id

  for (const tab of tabs) {
    const el = document.getElementById(panelId(tab.id))
    if (!el) continue
    if (el.getBoundingClientRect().top - offset <= 1) {
      current = tab.id
    }
  }

  if (activeTab.value !== current) {
    activeTab.value = current
  }
}

function onWindowScroll() {
  if (scrollSpyRaf) return
  scrollSpyRaf = window.requestAnimationFrame(() => {
    scrollSpyRaf = 0
    fitBuyPanelToViewport()
    syncActiveTabByScroll()
  })
}

function applyTabQuery(scroll = false) {
  const tab = String(route.query.tab ?? '')
  if (!tabs.some((item) => item.id === tab)) return
  const id = tab as TabId
  if (scroll) {
    void nextTick(() => scrollToTab(id))
  } else {
    activeTab.value = id
  }
}

function onWindowResize() {
  fitBuyPanelToViewport()
  syncGalleryHeight()
}

onMounted(() => {
  void loadSnippets([
    'mall.product.trust_badge',
    'mall.product.shipping_notes',
    'mall.product.return_policy',
    'mall.product.same_day_cutoff',
  ])
  void nextTick(() => bindGalleryHeightSync())
  window.addEventListener('scroll', onWindowScroll, { passive: true })
  window.addEventListener('resize', onWindowResize, { passive: true })
  window.visualViewport?.addEventListener('resize', onWindowResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onWindowScroll)
  window.removeEventListener('resize', onWindowResize)
  window.visualViewport?.removeEventListener('resize', onWindowResize)
  buyResizeObserver?.disconnect()
  buyResizeObserver = null
  window.clearTimeout(scrollUnlockTimer)
  if (scrollSpyRaf) window.cancelAnimationFrame(scrollSpyRaf)
})

watch(
  () => route.params.id,
  () => {
    qty.value = 1
    lastPurchaseQty.value = null
    selectedLines.value = []
    optionPick.value = ''
    activeTab.value = 'detail'
    toast.value = ''
    window.scrollTo({ top: 0, behavior: 'smooth' })
    loadProduct().then(() => {
      void nextTick(() => {
        bindGalleryHeightSync()
        applyTabQuery(true)
      })
    })
  },
)

watch(
  () => [product.value?.id, selectedLines.value.length, optionPick.value] as const,
  () => {
    void nextTick(() => {
      fitBuyPanelToViewport()
      syncGalleryHeight()
    })
  },
)

watch(isLoggedIn, (loggedIn) => {
  if (loggedIn && product.value) {
    void loadLastPurchase(product.value.id)
    void loadQnaOrders()
  } else {
    lastPurchaseQty.value = null
    qnaOrders.value = []
    qnaForm.orderCode = ''
    qnaForm.kind = ''
  }
})

watch(
  () => route.query.tab,
  () => {
    applyTabQuery(true)
  },
)

watch(product, (value) => {
  if (!value) return
  void nextTick(() => syncActiveTabByScroll())
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "product-detail",
    style: _normalizeStyle(stickyCssVars.value)
  }, [
    (product.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("nav", _hoisted_2, [
              _createVNode(_component_router_link, { to: "/mall" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("함우리몰", -1)
                ]))]),
                _: 1
              }),
              _createVNode(AppIcon, {
                icon: "mdi-chevron-right",
                size: 16
              }),
              _createElementVNode("span", null, _toDisplayString(product.value.category), 1),
              _createVNode(AppIcon, {
                icon: "mdi-chevron-right",
                size: 16
              }),
              _createElementVNode("em", null, _toDisplayString(product.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                ref_key: "galleryEl",
                ref: galleryEl,
                class: "product-detail__gallery"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (gallery.value.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gallery.value, (image, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${image}-${index}`
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass({ 'is-active': index === activeImageIndex.value }),
                              "aria-label": `${product.value.name} 이미지 ${index + 1}`,
                              onClick: ($event: any) => (activeImageIndex.value = index)
                            }, [
                              _createElementVNode("img", {
                                src: image,
                                alt: `${product.value.name} 이미지 ${index + 1}`,
                                loading: "lazy"
                              }, null, 8, _hoisted_7)
                            ], 10, _hoisted_6)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "product-detail__hero",
                    onTouchstartPassive: onHeroTouchStart,
                    onTouchendPassive: onHeroTouchEnd
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "product-detail__hero-btn",
                      "aria-label": "이미지 확대 보기",
                      onClick: openZoom
                    }, [
                      _createElementVNode("img", {
                        src: activeImage.value,
                        alt: product.value.name,
                        class: "product-detail__hero-img"
                      }, null, 8, _hoisted_8)
                    ]),
                    (product.value.badge)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(product.value.badge), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(imageCaption.value), 1),
                    (product.value.soldOut)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "품절"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "product-detail__zoom-fab",
                      "aria-label": "이미지 확대 보기",
                      onClick: openZoom
                    }, [
                      _createVNode(AppIcon, {
                        icon: "mdi-magnify-plus-outline",
                        size: 20
                      })
                    ])
                  ], 32)
                ]),
                (gallery.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "product-detail__pager-btn",
                        "aria-label": "이전 사진",
                        disabled: !canGoPrev.value,
                        onClick: prevImage
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-chevron-left",
                          size: 22
                        })
                      ], 8, _hoisted_13),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(activeImageIndex.value + 1) + " / " + _toDisplayString(gallery.value.length), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "product-detail__pager-btn",
                        "aria-label": "다음 사진",
                        disabled: !canGoNext.value,
                        onClick: nextImage
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-chevron-right",
                          size: 22
                        })
                      ], 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ], 512),
              (zoomOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "product-detail__zoom",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": "상품 이미지 확대",
                    onClick: _withModifiers(closeZoom, ["self"])
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "product-detail__zoom-close",
                      "aria-label": "닫기",
                      onClick: closeZoom
                    }, [
                      _createVNode(AppIcon, {
                        icon: "mdi-close",
                        size: 22
                      })
                    ]),
                    _createElementVNode("img", {
                      src: activeImage.value,
                      alt: product.value.name,
                      class: "product-detail__zoom-img",
                      style: _normalizeStyle({ transform: `scale(${zoomScale.value})` }),
                      onWheel: _withModifiers(onZoomWheel, ["prevent"]),
                      onTouchstartPassive: onPinchStart,
                      onTouchmovePassive: onPinchMove,
                      onTouchendPassive: onPinchEnd
                    }, null, 44, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  ref_key: "tabsEl",
                  ref: tabsEl,
                  class: "product-detail__tabs",
                  role: "tablist",
                  "aria-label": "상품 정보 탭"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                    return _createElementVNode("button", {
                      key: tab.id,
                      type: "button",
                      role: "tab",
                      class: _normalizeClass(["product-detail__tab", { 'is-active': activeTab.value === tab.id }]),
                      "aria-selected": activeTab.value === tab.id,
                      id: `tab-${tab.id}`,
                      "aria-controls": `panel-${tab.id}`,
                      onClick: ($event: any) => (scrollToTab(tab.id))
                    }, [
                      _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                      (tab.id === 'review')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(product.value.reviewCount), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_18)
                  }), 64))
                ], 512),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("section", _hoisted_20, [
                    (product.value.highlights.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[11] || (_cache[11] = _createElementVNode("h2", { id: "product-specs-title" }, "상품정보", -1)),
                            (product.value.highlights.length > 4)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "product-detail__specs-toggle",
                                  "aria-expanded": specsOpen.value,
                                  "aria-controls": "product-specs",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (specsOpen.value = !specsOpen.value))
                                }, [
                                  _createTextVNode(_toDisplayString(specsOpen.value ? '접기' : `전체 ${product.value.highlights.length}개 보기`) + " ", 1),
                                  _createVNode(AppIcon, {
                                    icon: specsOpen.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                                    size: 18
                                  }, null, 8, ["icon"])
                                ], 8, _hoisted_22))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("dl", {
                            id: "product-specs",
                            class: _normalizeClass(["product-detail__specs", { 'is-collapsed': product.value.highlights.length > 4 && !specsOpen.value }]),
                            "aria-labelledby": "product-specs-title"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleHighlights.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.label
                              }, [
                                _createElementVNode("dt", null, _toDisplayString(item.label), 1),
                                _createElementVNode("dd", null, _toDisplayString(item.value), 1)
                              ]))
                            }), 128))
                          ], 2)
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "product-detail__section-title" }, "상세 설명", -1)),
                    (product.value.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(product.value.description), 1))
                      : _createCommentVNode("", true),
                    (detailBlocks.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailBlocks.value, (block, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (block.type === 'HEADING')
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_25, _toDisplayString(block.text), 1))
                                : (block.type === 'TEXT')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(block.text), 1))
                                  : (block.type === 'NOTICE')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                        _createVNode(AppIcon, {
                                          icon: "mdi-information-outline",
                                          size: 16
                                        }),
                                        _createTextVNode(" " + _toDisplayString(block.text), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("figure", _hoisted_28, [
                                        _createElementVNode("img", {
                                          src: block.imageUrl,
                                          alt: block.alt || product.value.name,
                                          loading: "lazy"
                                        }, null, 8, _hoisted_29),
                                        (block.alt)
                                          ? (_openBlock(), _createElementBlock("figcaption", _hoisted_30, _toDisplayString(block.alt), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_31, [
                      _createElementVNode("li", null, _toDisplayString(trustBadge.value), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "product-detail__notice-html",
                      innerHTML: shippingNotesHtml.value
                    }, null, 8, _hoisted_32)
                  ]),
                  _createElementVNode("section", _hoisted_33, [
                    _createElementVNode("h2", null, "구매후기 " + _toDisplayString(product.value.reviewCount), 1),
                    (canWriteReview.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "product-detail__write-lead" }, "구매하신 상품에 대한 후기를 남겨 주세요.", -1)),
                          (qnaOrders.value.length)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_35, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "관련 주문", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reviewForm.orderCode) = $event)),
                                  disabled: qnaOrdersLoading.value
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qnaOrders.value, (order) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: order.code,
                                      value: order.code
                                    }, _toDisplayString(formatQnaOrderOption(order)), 9, _hoisted_37))
                                  }), 128))
                                ], 8, _hoisted_36), [
                                  [_vModelSelect, reviewForm.orderCode]
                                ]),
                                _cache[14] || (_cache[14] = _createElementVNode("em", null, "이 후기가 어느 주문에 대한 것인지 판매업체·관리자가 바로 봅니다.", -1))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_38, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                              return _createElementVNode("button", {
                                key: star,
                                type: "button",
                                class: _normalizeClass(["product-detail__star-btn", { 'is-on': star <= reviewForm.rating }]),
                                "aria-label": `${star}점`,
                                onClick: ($event: any) => (reviewForm.rating = star)
                              }, [
                                _createVNode(AppIcon, {
                                  icon: star <= reviewForm.rating ? 'mdi-star' : 'mdi-star-outline',
                                  size: 22
                                }, null, 8, ["icon"])
                              ], 10, _hoisted_39)
                            }), 64))
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((reviewForm.content) = $event)),
                            class: "product-detail__write-input",
                            rows: "3",
                            maxlength: "2000",
                            placeholder: "배송 · 품질 · 포장 등 실제 사용 느낌을 적어 주세요."
                          }, null, 512), [
                            [
                              _vModelText,
                              reviewForm.content,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("label", _hoisted_41, [
                              _createVNode(AppIcon, {
                                icon: "mdi-camera-outline",
                                size: 18
                              }),
                              _createTextVNode(" " + _toDisplayString(reviewImagePreview.value ? '사진 바꾸기' : '사진 첨부') + " ", 1),
                              _createElementVNode("input", {
                                type: "file",
                                accept: "image/jpeg,image/png,image/webp,image/gif",
                                hidden: "",
                                onChange: onReviewImagePick
                              }, null, 32)
                            ]),
                            (reviewImagePreview.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "product-detail__photo-clear",
                                  onClick: clearReviewImage
                                }, " 사진 삭제 "))
                              : _createCommentVNode("", true),
                            (reviewImagePreview.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: reviewImagePreview.value,
                                  alt: "첨부 미리보기",
                                  class: "product-detail__photo-preview"
                                }, null, 8, _hoisted_42))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "product-detail__btn product-detail__btn--solid",
                            disabled: reviewBusy.value || !reviewForm.content,
                            onClick: submitReview
                          }, _toDisplayString(reviewBusy.value ? '등록 중…' : '구매후기 등록'), 9, _hoisted_43)
                        ]))
                      : (myReview.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_44, "이미 구매후기를 작성하셨습니다."))
                        : (isLive.value && _unref(isLoggedIn))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, " 입금이 확인된 구매 건이 있을 때만 구매후기를 남길 수 있습니다. "))
                          : _createCommentVNode("", true),
                    (product.value.reviews.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["product-detail__filter-chip", { 'is-on': !photoReviewsOnly.value }]),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (photoReviewsOnly.value = false))
                          }, " 전체 " + _toDisplayString(product.value.reviews.length), 3),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["product-detail__filter-chip", { 'is-on': photoReviewsOnly.value }]),
                            disabled: !photoReviewCount.value,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (photoReviewsOnly.value = true))
                          }, " 포토후기 " + _toDisplayString(photoReviewCount.value), 11, _hoisted_47)
                        ]))
                      : _createCommentVNode("", true),
                    (visibleReviews.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleReviews.value, (review) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: review.id,
                              class: "product-detail__review"
                            }, [
                              _createElementVNode("header", null, [
                                _createElementVNode("strong", null, _toDisplayString(review.author), 1),
                                _createElementVNode("span", null, _toDisplayString(review.org), 1),
                                _createElementVNode("em", null, [
                                  _createVNode(AppIcon, {
                                    icon: "mdi-star",
                                    size: 14
                                  }),
                                  _createTextVNode(" " + _toDisplayString(review.rating.toFixed(1)), 1)
                                ]),
                                _createElementVNode("time", null, _toDisplayString(review.date), 1)
                              ]),
                              _createElementVNode("p", null, _toDisplayString(review.content), 1),
                              (review.image)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: review.image,
                                    class: "product-detail__review-photo",
                                    target: "_blank",
                                    rel: "noopener"
                                  }, [
                                    _createElementVNode("img", {
                                      src: review.image,
                                      alt: "후기 사진"
                                    }, null, 8, _hoisted_50)
                                  ], 8, _hoisted_49))
                                : _createCommentVNode("", true),
                              (review.reply)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _cache[16] || (_cache[16] = _createElementVNode("strong", null, "판매업체 답변", -1)),
                                    _createElementVNode("p", null, _toDisplayString(review.reply), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(photoReviewsOnly.value ? '포토후기가 없습니다.' : '등록된 구매후기가 없습니다.'), 1))
                  ]),
                  _createElementVNode("section", _hoisted_53, [
                    _createElementVNode("h2", null, "상품문의 " + _toDisplayString((product.value.qnas || []).length), 1),
                    (_unref(isLoggedIn))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "product-detail__write-lead" }, " 이 상품이 들어간 주문을 고른 뒤 문의를 남깁니다. 그 밖 문의도 문의 내역에서 작성합니다. ", -1)),
                          _createElementVNode("p", _hoisted_55, [
                            _createVNode(_component_router_link, { to: "/mall/mypage/consults" }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode("문의 내역", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("label", _hoisted_56, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", null, "관련 주문", -1)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((qnaForm.orderCode) = $event)),
                              disabled: qnaOrdersLoading.value || !qnaOrders.value.length
                            }, [
                              _cache[18] || (_cache[18] = _createElementVNode("option", {
                                value: "",
                                disabled: ""
                              }, "주문내역에서 고르세요", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qnaOrders.value, (order) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: order.code,
                                  value: order.code
                                }, _toDisplayString(formatQnaOrderOption(order)), 9, _hoisted_58))
                              }), 128))
                            ], 8, _hoisted_57), [
                              [_vModelSelect, qnaForm.orderCode]
                            ]),
                            (qnaOrdersLoading.value)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_59, "주문 목록을 불러오는 중…"))
                              : (!qnaOrders.value.length)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_60, " 이 상품이 들어 있는 주문이 없습니다. 문의 내역에서 주문번호를 첨부해 작성해 주세요. "))
                                : _createCommentVNode("", true)
                          ]),
                          (qnaForm.orderCode)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((qnaForm.question) = $event)),
                                  class: "product-detail__write-input",
                                  rows: "3",
                                  maxlength: "2000",
                                  placeholder: "선택한 주문에 대해 궁금한 점을 적어 주세요."
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    qnaForm.question,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("label", _hoisted_61, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((qnaForm.secret) = $event)),
                                    type: "checkbox"
                                  }, null, 512), [
                                    [_vModelCheckbox, qnaForm.secret]
                                  ]),
                                  _cache[20] || (_cache[20] = _createTextVNode(" 비밀글로 문의하기 ", -1))
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "product-detail__btn product-detail__btn--solid",
                                  disabled: qnaBusy.value || !qnaForm.question || !qnaForm.orderCode,
                                  onClick: submitQna
                                }, _toDisplayString(qnaBusy.value ? '등록 중…' : '문의 등록'), 9, _hoisted_62)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_63, [
                          _cache[23] || (_cache[23] = _createTextVNode(" 문의는 로그인 후 작성할 수 있습니다. ", -1)),
                          _createVNode(_component_router_link, { to: loginTo.value }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("로그인하기", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])),
                    ((product.value.qnas || []).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.qnas || [], (item) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: item.id,
                              class: "product-detail__review"
                            }, [
                              _createElementVNode("header", null, [
                                _createElementVNode("strong", null, _toDisplayString(item.author), 1),
                                _createElementVNode("span", null, _toDisplayString(item.org), 1),
                                (item.secret)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "비밀글"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("time", null, _toDisplayString(item.date), 1)
                              ]),
                              _createElementVNode("p", null, _toDisplayString(qnaVisibleText(item)), 1),
                              (canSeeQna(item))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (item.answer)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                          _cache[24] || (_cache[24] = _createElementVNode("strong", null, "답변", -1)),
                                          _createElementVNode("p", null, _toDisplayString(item.answer), 1),
                                          (item.answeredAt)
                                            ? (_openBlock(), _createElementBlock("em", _hoisted_67, _toDisplayString(item.answeredAt), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_68, "답변 대기 중"))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_69, "등록된 문의가 없습니다."))
                  ]),
                  _createElementVNode("section", _hoisted_70, [
                    _cache[31] || (_cache[31] = _createElementVNode("h2", null, "배송 · 교환 · 반품", -1)),
                    _createElementVNode("dl", _hoisted_71, [
                      _createElementVNode("div", null, [
                        _cache[25] || (_cache[25] = _createElementVNode("dt", null, "배송비", -1)),
                        _createElementVNode("dd", null, _toDisplayString(productShippingLabel.value), 1)
                      ]),
                      (product.value.leadTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            _cache[26] || (_cache[26] = _createElementVNode("dt", null, "출고", -1)),
                            _createElementVNode("dd", null, _toDisplayString(product.value.leadTime), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("dt", null, "수령", -1)),
                        _createElementVNode("dd", null, _toDisplayString(_unref(MALL_FULFILLMENT_LIMIT)), 1)
                      ]),
                      (product.value.origin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _cache[28] || (_cache[28] = _createElementVNode("dt", null, "원산지", -1)),
                            _createElementVNode("dd", null, _toDisplayString(product.value.origin), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(sameDayCutoffText))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _cache[29] || (_cache[29] = _createElementVNode("dt", null, "당일 출고", -1)),
                            _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (hasStoreReturnFee.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _cache[30] || (_cache[30] = _createElementVNode("dt", null, "반품 배송비", -1)),
                            _createElementVNode("dd", null, _toDisplayString(returnShippingLabel.value), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (storeReturnPolicyLines.value.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_76, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeReturnPolicyLines.value, (line, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `pol-${index}`
                            }, _toDisplayString(line), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "product-detail__notice-html",
                          innerHTML: returnPolicyHtml.value
                        }, null, 8, _hoisted_77))
                  ])
                ]),
                (product.value.soldOut && substitutes.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_78, [
                      _cache[32] || (_cache[32] = _createElementVNode("h2", null, "관련상품", -1)),
                      _cache[33] || (_cache[33] = _createElementVNode("p", { class: "product-detail__related-lead" }, "품절 상품의 대체 가능한 관련상품입니다.", -1)),
                      _createElementVNode("div", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(substitutes.value, (item) => {
                          return (_openBlock(), _createBlock(ProductCard, {
                            key: `sub-${item.id}`,
                            product: item
                          }, null, 8, ["product"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (related.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
                      _cache[34] || (_cache[34] = _createElementVNode("h2", null, "관련상품", -1)),
                      _createElementVNode("div", _hoisted_81, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(related.value, (item) => {
                          return (_openBlock(), _createBlock(ProductCard, {
                            key: item.id,
                            product: item
                          }, null, 8, ["product"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (alsoRecommend.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_82, [
                      _cache[35] || (_cache[35] = _createElementVNode("h2", null, "추천상품", -1)),
                      _createElementVNode("div", _hoisted_83, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alsoRecommend.value, (item) => {
                          return (_openBlock(), _createBlock(ProductCard, {
                            key: `rec-${item.id}`,
                            product: item
                          }, null, 8, ["product"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (recentOthers.value.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_84, [
                      _cache[36] || (_cache[36] = _createElementVNode("h2", null, "오늘 본 상품", -1)),
                      _createElementVNode("div", _hoisted_85, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentOthers.value, (item) => {
                          return (_openBlock(), _createBlock(ProductCard, {
                            key: `rv-${item.id}`,
                            product: item
                          }, null, 8, ["product"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("aside", {
                ref_key: "buyEl",
                ref: buyEl,
                class: "product-detail__buy",
                "aria-label": "구매 정보"
              }, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        (product.value.storeName && product.value.sellerCode)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: _unref(mallStorePath)(product.value.sellerCode),
                              class: "product-detail__store"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(product.value.storeName) + " ", 1),
                                _createVNode(AppIcon, {
                                  icon: "mdi-chevron-right",
                                  size: 16
                                })
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : (product.value.storeName)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(product.value.storeName), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "product-detail__compare",
                            onClick: onShare
                          }, " 공유하기 "),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["product-detail__compare", { 'is-on': wished.value }]),
                            onClick: onWish
                          }, " 찜하기 ", 2)
                        ])
                      ]),
                      _createElementVNode("h1", _hoisted_92, _toDisplayString(product.value.name), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "product-detail__rating",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (scrollToTab('review')))
                      }, [
                        _createElementVNode("span", _hoisted_93, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                            return _createVNode(AppIcon, {
                              key: star,
                              icon: star <= Math.round(product.value.rating) ? 'mdi-star' : 'mdi-star-outline',
                              size: 15
                            }, null, 8, ["icon"])
                          }), 64))
                        ]),
                        _createElementVNode("strong", null, _toDisplayString(product.value.rating.toFixed(1)), 1),
                        _createElementVNode("em", null, "구매후기 " + _toDisplayString(_unref(formatPrice)(product.value.reviewCount)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        (isGroupBuy.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                              _createTextVNode(_toDisplayString(_unref(formatPrice)(cartonPrice.value)), 1),
                              _cache[37] || (_cache[37] = _createElementVNode("em", null, "원", -1)),
                              _cache[38] || (_cache[38] = _createElementVNode("small", null, "/카톤", -1))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_97, [
                              _createTextVNode(_toDisplayString(_unref(formatPrice)(priced.value.unitPrice)), 1),
                              _cache[39] || (_cache[39] = _createElementVNode("em", null, "원", -1)),
                              _createElementVNode("small", null, "/" + _toDisplayString(sellNoun.value), 1)
                            ]))
                      ]),
                      (isGroupBuy.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(cartonPieces.value) + "개 묶음 · 1개당 " + _toDisplayString(_unref(formatPrice)(priced.value.unitPrice)) + "원", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_99, [
                            _createTextVNode(_toDisplayString(sellSummary.value), 1),
                            (product.value.unit)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(product.value.unit), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])),
                      _createElementVNode("p", {
                        class: _normalizeClass(["product-detail__stock", { 'is-out': product.value.soldOut || stockQty.value <= 0 }])
                      }, [
                        (product.value.soldOut || stockQty.value <= 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("품절")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("재고 " + _toDisplayString(_unref(formatStockCount)(stockQty.value, product.value.sellUnit)), 1)
                            ], 64))
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("dl", _hoisted_101, [
                        _createElementVNode("div", null, [
                          _cache[40] || (_cache[40] = _createElementVNode("dt", null, "배송비", -1)),
                          _createElementVNode("dd", null, _toDisplayString(productShippingLabel.value), 1)
                        ]),
                        (product.value.leadTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _cache[41] || (_cache[41] = _createElementVNode("dt", null, "출고", -1)),
                              _createElementVNode("dd", null, _toDisplayString(product.value.leadTime), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _cache[42] || (_cache[42] = _createElementVNode("dt", null, "수령", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_unref(MALL_FULFILLMENT_LIMIT)), 1)
                        ]),
                        (product.value.origin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              _cache[43] || (_cache[43] = _createElementVNode("dt", null, "원산지", -1)),
                              _createElementVNode("dd", null, _toDisplayString(product.value.origin), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(sameDayCutoffText))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                              _cache[44] || (_cache[44] = _createElementVNode("dt", null, "당일 출고", -1)),
                              _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        (!isGroupBuy.value)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_107, [...(_cache[45] || (_cache[45] = [
                              _createTextVNode(" 옵션 선택 ", -1),
                              _createElementVNode("em", null, "(필수)", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (!isGroupBuy.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 1,
                              id: "pdp-option-pick",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((optionPick).value = $event)),
                              class: "product-detail__option-select",
                              disabled: product.value.soldOut || !flatOptionChoices.value.length,
                              onChange: onOptionPick
                            }, [
                              (!hasBasePriceChoice.value)
                                ? (_openBlock(), _createElementBlock("option", _hoisted_109, "옵션을 선택하세요"))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatOptionChoices.value, (choice) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: choice.name,
                                  value: choice.name,
                                  disabled: !isChoiceAvailable(choice)
                                }, _toDisplayString(choiceLabel(choice)), 9, _hoisted_110))
                              }), 128))
                            ], 40, _hoisted_108)), [
                              [_vModelSelect, optionPick.value]
                            ])
                          : _createCommentVNode("", true),
                        (isPack.value && !isGroupBuy.value)
                          ? (_openBlock(), _createBlock(MallOrderPackMark, {
                              key: 2,
                              size: "detail",
                              "order-step": orderStep.value,
                              "sell-unit": product.value.sellUnit
                            }, null, 8, ["order-step", "sell-unit"]))
                          : _createCommentVNode("", true),
                        (selectedLines.value.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_111, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLines.value, (line) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: line.key
                                }, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("strong", null, _toDisplayString(isGroupBuy.value ? '1카톤' : line.optionName), 1),
                                    (isGroupBuy.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(_unref(formatPrice)(lineUnitPrice(line.optionExtra) * cartonPieces.value)) + "원 × " + _toDisplayString(cartonCount(line.qty)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(_unref(formatPrice)(lineUnitPrice(line.optionExtra))) + "원 × " + _toDisplayString(line.qty), 1))
                                  ]),
                                  _createElementVNode("div", _hoisted_115, [
                                    _createVNode(QtyStepper, {
                                      "model-value": line.qty,
                                      min: minQty.value,
                                      max: maxQty.value,
                                      step: orderStep.value,
                                      unit: sellNoun.value,
                                      carton: isGroupBuy.value,
                                      "onUpdate:modelValue": ($event: any) => (setLineQty(line.key, $event))
                                    }, null, 8, ["model-value", "min", "max", "step", "unit", "carton", "onUpdate:modelValue"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (lastPurchaseQty.value && selectedLines.value.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              type: "button",
                              class: "product-detail__last-qty",
                              onClick: applyLastPurchase
                            }, " 지난번 " + _toDisplayString(isGroupBuy.value ? `${cartonCount(lastPurchaseQty.value)}카톤` : `${lastPurchaseQty.value}${sellNoun.value}`) + "로 맞추기 ", 1))
                          : _createCommentVNode("", true),
                        (qtyHint.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(qtyHint.value), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _cache[46] || (_cache[46] = _createElementVNode("span", null, "주문금액", -1)),
                        (orderShippingFee.value > 0)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_120, " 주문 배송비 " + _toDisplayString(_unref(formatPrice)(orderShippingFee.value)) + "원 포함 ", 1))
                          : (_openBlock(), _createElementBlock("em", _hoisted_121, "주문 배송비 무료"))
                      ]),
                      _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(_unref(formatPrice)(totalAmount.value)), 1),
                        _cache[47] || (_cache[47] = _createElementVNode("em", null, "원", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      (product.value.soldOut)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass(["product-detail__cta product-detail__cta--restock", { 'is-on': restockSubscribed.value }]),
                            disabled: restockBusy.value,
                            onClick: toggleRestock
                          }, _toDisplayString(restockSubscribed.value ? '재입고 알림 신청됨' : '재입고 알림 신청'), 11, _hoisted_123))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "product-detail__cta product-detail__cta--buy",
                            onClick: buyNow
                          }, " 바로구매 ")),
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["product-detail__tool", { 'is-active': wished.value }]),
                          onClick: onWish
                        }, [
                          _createVNode(AppIcon, {
                            icon: wished.value ? 'mdi-heart' : 'mdi-heart-outline',
                            size: 20
                          }, null, 8, ["icon"]),
                          _cache[48] || (_cache[48] = _createTextVNode(" 찜하기 ", -1))
                        ], 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: "product-detail__tool",
                          disabled: product.value.soldOut,
                          onClick: addToCart
                        }, [
                          _createVNode(AppIcon, {
                            icon: "mdi-cart-outline",
                            size: 20
                          }),
                          _cache[49] || (_cache[49] = _createTextVNode(" 장바구니 ", -1))
                        ], 8, _hoisted_125)
                      ])
                    ]),
                    (!_unref(isLoggedIn))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_126, " 장바구니 · 찜하기 · 바로구매는 로그인 후 이용할 수 있습니다. "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_Transition, { name: "detail-toast" }, {
                  default: _withCtx(() => [
                    (toast.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_127, [
                          _createVNode(AppIcon, {
                            icon: "mdi-check-circle",
                            size: 18
                          }),
                          _createTextVNode(" " + _toDisplayString(toast.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["product-detail__like", { 'is-active': wished.value }]),
              "aria-label": "찜하기",
              onClick: onWish
            }, [
              _createVNode(AppIcon, {
                icon: wished.value ? 'mdi-heart' : 'mdi-heart-outline',
                size: 22
              }, null, 8, ["icon"])
            ], 2),
            _createElementVNode("button", {
              type: "button",
              class: "product-detail__cart",
              disabled: product.value.soldOut,
              onClick: addToCart
            }, " 장바구니 ", 8, _hoisted_129),
            (product.value.soldOut)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["product-detail__buy-btn product-detail__buy-btn--restock", { 'is-on': restockSubscribed.value }]),
                  disabled: restockBusy.value,
                  onClick: toggleRestock
                }, _toDisplayString(restockSubscribed.value ? '알림 신청됨' : '재입고 알림'), 11, _hoisted_130))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "product-detail__buy-btn",
                  onClick: buyNow
                }, "바로구매"))
          ])
        ], 64))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 48
            }),
            _cache[50] || (_cache[50] = _createElementVNode("p", null, "상품을 불러오는 중입니다…", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_132, [
            _createVNode(AppIcon, {
              icon: "mdi-package-variant",
              size: 64
            }),
            _cache[52] || (_cache[52] = _createElementVNode("p", null, "해당 상품을 찾을 수 없습니다.", -1)),
            _createVNode(_component_router_link, {
              to: "/mall",
              class: "product-detail__missing-link"
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createTextVNode("함우리몰 홈으로", -1)
              ]))]),
              _: 1
            })
          ]))
  ], 4))
}
}

})